export * from './branches-list.component';



// WEBPACK FOOTER //
// ./src/app/components/branches-list/index.ts